import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

// Session expirée sur une page protégée → mémorise la page puis redirige vers Connexion
const PROTECTED = ["/dashboard", "/admin", "/partner", "/shipments"];
api.interceptors.response.use(
  (r) => r,
  (error) => {
    const status = error.response?.status;
    const path = window.location.pathname;
    const isAuthCall = (error.config?.url || "").includes("/auth/");
    if (status === 401 && !isAuthCall && PROTECTED.some((p) => path.startsWith(p))) {
      sessionStorage.setItem("redirect_after_login", path + window.location.search);
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default api;
